import { Stack } from '@mui/material'
import React, { useState, useEffect }  from 'react'
import { fetchAPI } from '@/utility/NetworkUtils'
import Loading from '@/shared/Loading'
import { renderButton, renderSelectFieldFilterable, renderTextField } from '@/shared/FormUtils'

const EventUsersForm = (props) => {
  const { event, formikProps } = props
  const [ availableUsers, setAvailableUsers ] = useState([])
  const [ loading, setLoading ] = useState(false)

  useEffect(() => {
    fetchUsers()
  }, [])

  const fetchUsers = () => {
    setLoading(true)
    fetchAPI(`/webapi/users`, (json)=> {
      if (!json.errors) {
        setAvailableUsers(json.users)
        setLoading(false)
      } else {
        console.log({
          errors: json.errors
        })
      }
    }, {});
  }

  const getUsers = () => {
    return availableUsers.filter((user) => {
      return user.role == 'client' 
      &&
      !(formikProps.values.user_ids||[]).includes(user.id)
    })
    .map(x=> {
      return {value: x.id, label: `${x.first_name||""} ${x.last_name||""} (${x.email})`}
    })
  }

  const renderUsers = () => {
    const users = (formikProps.values.user_ids||[]).map(x=> {
      return availableUsers.find(user => user.id == x)
    }).filter(x=>x)
    console.log({
      users
    })
    return users.map(user => {
      console.log({
        user
      })
      return (
        <div className="flex border-b-1 border-[#e6e6e6] pb-4" key={`user_${user.id}`} style={{borderBottom: "1px solid #e6e6e6"}}>
          <div className="w-full">
            <b>
              {`${user.first_name} ${user.last_name}`}
            </b>
          </div>
          <div className="flex align-middle px-8 items-center">
            <a href="javascript:void(0)" className="text-blue-600" onClick={(e) => {
              e.preventDefault()
              formikProps.setFieldValue("user_ids", 
                formikProps.values.user_ids.filter(x => x !== user.id)
              )
            }}>
              Remove
            </a>
          </div>
        </div>
      )
    })
  }

  if(loading) {
    return <Loading />
  }
  return (
    <Stack direction="column" spacing={2}>
      <div>
        Users will be allowed to make and remove holds on this event.
      </div>
      <div className="flex">
        {renderSelectFieldFilterable(
          "Users",
          "select_user_id",
          getUsers(),
          {
            onChange: (e) => {
              formikProps.setFieldValue("user_ids", 
                [...formikProps.values.user_ids, e].filter((x,i,a) => a.indexOf(x) === i)
              )
              formikProps.setFieldValue("select_user_id", "")
            }
          }
        )}
        <div className="pl-2 pt-[1.4rem]">
        </div>
      </div>
      {renderUsers()}
    </Stack>
  )

}

export default EventUsersForm
